import { useOrg } from '../use-org';
export function useV3OrgIdStatus() {
  const [{
    orgId
  }] = useOrg();
  return {
    orgId,
    isOrgLoading: !orgId
  };
}